const state = {
    platList: [
        {label: '权利卫士', value: 0},
        {label: '知识产权', value: 1},
        {label: '证据平台', value: 2},
    ],
    businessTypes: [
        { name: 'PDF服务', value: 'PDF_FORWARD_SERVICE' },
        { name: '网页取证', value: 'EVIDENCE_WEBPAGE' },
        { name: '网页取证（增强版）', value: 'EVIDENCE_WEBPAGE_PLUS' },
        { name: '录屏取证', value: 'EVIDENCE_RECORD_SCREEN' },
        { name: '境外取证', value: 'EVIDENCE_RECORD_OVERSEAS' },
        { name: '自动录屏取证', value: 'EVIDENCE_VIDEO' },
        { name: '权利卫士-拍照取证', value: 'GUARD_TAKE_PHOTO' },
        { name: '权利卫士-录像取证', value: 'GUARD_RECORD_VIDEO' },
        { name: '权利卫士-录音取证', value: 'GUARD_RECORD_AUDIO' },
        { name: '权利卫士-网页取证', value: 'GUARD_EVIDENCE_WEBPAGE' },
        { name: '权利卫士-录屏取证', value: 'GUARD_RECORD_SCREEN' },
        { name: '知识产权-可信时间戳认证', value: 'COPYRIGHT' },
        { name: '知识产权-存储服务', value: 'COPYRIGHT_STORAGE' },
        { name: 'AIGC 创作过程认证', value: 'COPYRIGHT_AIGC' },
        { name: '邮件认证-可信时间戳认证', value: 'EMAIL_PROOF' },
        { name: '邮件认证-存储服务', value: 'EMAIL_PROOF_STORAGE' },
        { name: '软著登记保护-可信时间戳认证', value: 'SOFTWARE_COPYRIGHT' },
        { name: '软著登记保护-存储服务', value: 'SOFTWARE_COPYRIGHT_STORAGE' },
        
        // { name: '时间戳', value: 'TIMESTAMP' },
        // { name: '充值', value: 'RECHARGE' },
        // { name: '电子签名', value: 'SIGN_CONTRACT' },
        // { name: '壹签', value: 'ONE_SIGN' },
        // { name: '代码确权', value: 'CODE_COPYRIGHT' },
        // { name: '手机取证', value: 'EVIDENCE_PHONE' },
        // { name: '在线音频/视频取证', value: 'EVIDENCE_ONLINE_AUDIO_VIDEO' },
    ],
    platListState: [
        {
            val: 955210,
            name: "时间戳",
        },
        {
            val: 955740,
            name: "电子证据",
        },
        {
            val: 952310,
            name: "知识产权",
        },
        {
            val: 700025,
            name: "邮件认证平台",
        },
        {
            val: 954210,
            name: "权利卫士",
        },
        {
            val: 700023,
            name: "软著保护平台",
        },
        // {
        //     val: 975260,
        //     name: "用户中心",
        // },

        // {
        //     val: 955255,
        //     name: "RA",
        // },
        // {
        //     val: 995280,
        //     name: "经销商前台",
        // },
        // {
        //     val: 915290,
        //     name: "经销商后台",
        // },

        // {
        //     val: 925220,
        //     name: "电子签名",
        // },

        // {
        //     val: 975281,
        //     name: "维权平台",
        // },
        // {
        //     val: 800001,
        //     name: "天平阳光",
        // },
        // {
        //     val: 801001,
        //     name: "百度",
        // },
    ],
}
const mutations = {}
const actions = {}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
